import { VStack } from "@chakra-ui/react";
import { useUserContext } from "../../../../Contexts/userContext";
import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import { User } from "../../../../services/Dtos";
import Empty from "../../../CustomUi/Empty";
import UserCard from "./UserCard";

interface Props {
  editUser: (user: User) => void;
}

export default function UsersTable({ editUser }: Props) {
  const { users } = useSchoolsContext();
  const { user } = useUserContext();

  const filteredUsers = users.filter((u) => u.id !== user?.id);

  if (filteredUsers.length === 0) {
    return (
      <Empty
        message="No users found"
        description="There are no users to display at the moment."
        height="200px"
        hidePicture={true}
      />
    );
  }

  return (
    <VStack gap={4} align="stretch">
      {filteredUsers.map((u) => (
        <UserCard key={u.id} user={u} handleClick={() => editUser(u)} />
      ))}
    </VStack>
  );
}
